import { colorBlend } from './ColorTools';

const OVERALL_COLORS = colorBlend(2277);
const SKILL_COLORS = colorBlend(127);
const COMBAT_COLORS = colorBlend(126);

const getOverallColor = level => OVERALL_COLORS[level - 1];
const getSkillColor = level => SKILL_COLORS[level - 1];
const getCombatColor = level => COMBAT_COLORS[level - 1];

export { getOverallColor, getSkillColor, getCombatColor };



// WEBPACK FOOTER //
// ./src/utilities/color/color.js